/**
 * Login form validation schema
 * Validates email and password for login
 */

import * as Yup from 'yup'
import { FORM_LABELS, LABELS } from '@constants'
import { createEmailValidator } from '@utilities/validation'

export const loginValidationSchema = () =>
  Yup.object().shape({
    email: createEmailValidator(FORM_LABELS.INVALID_EMAIL)
      .required(FORM_LABELS.REQUIRED(LABELS.EMAIL)),
    password: Yup.string().required(FORM_LABELS.REQUIRED(LABELS.PASSWORD)),
  })
